const getChatSessions = async (userId) => {
  try {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    const response = await fetch(`${API_BASE_URL}/api/chat/getChatSessions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-SECRET': process.env.REACT_APP_NXTVID_API_SECRET,
      },
      body: JSON.stringify({ userId: userId }),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch chat sessions');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching chat sessions:', error);
    throw error;
  }
};

export default getChatSessions;
